<template>
  <div>
    <b-alert
      :show="this.OpdPtNoteDataInD && this.OpdPtNoteDataInD.length > 0"
      variant="dark"
      class="margin-bottom font12px"
    >
      <h6>PT (กายภาพบำบัด) {{ this.vnChang }}</h6>

      <b-row class="margin-bottom">
        <b-col lg="12" v-if="this.OpdPtNoteData">
          <b-list-group>
            <b-list-group-item style="color:#111111;">
              <div v-html="OpdPtNoteTextData" class="opd-pt-note-text"></div>

              <div class="log-style">
                Log. {{ this.OpdPtNoteData.datas.insert_fullname }} |
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    this.OpdPtNoteData.datas.insert_datetime
                  )
                }}
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row class="margin-bottom">
        <b-col lg="12">
          <b-list-group>
            <b-list-group-item
              v-for="item in this.OpdPtNoteDataInD"
              v-bind:key="item.id"
              style="color:#111111;"
            >
              <div v-html="item.datas.pt_text" class="opd-pt-note-text"></div>
              <hr class="hr-custom" />

              <div>
                <strong>สรุปผลการรักษา :</strong> {{ item.datas.pt_dch_name }}
                <strong>| หมายเหตุ :</strong>
                <div
                  v-html="item.datas.pt_dch_text"
                  class="opd-pt-note-text"
                ></div>
              </div>

              <div><strong>Dx กายภาพ :</strong></div>
              <div
                v-for="itemDxlist in PtDxListConfirm"
                v-bind:key="itemDxlist.id"
              >
                <b-col lg="12">
                  {{ "- " + itemDxlist.pt_indicators_name }}
                </b-col>
              </div>

              <div>
                <b-col lg="4">
                  <div><strong>PS :</strong> {{ item.datas.pt_ps_name }}</div>
                </b-col>
                <b-col lg="4">
                  <div><strong>BI :</strong> {{ item.datas.pt_bi_name }}</div>
                </b-col>
                <b-col lg="4">
                  <div>
                    <strong>MRM ROM ไหล่ :</strong>
                    {{ item.datas.pt_mrm_rom_name }}
                  </div>
                </b-col>
              </div>
              <div>
                <b-col lg="4">
                  <div>
                    <strong>TKA ROM เข่า :</strong>
                    {{ item.datas.pt_tka_rom_name }}
                  </div>
                </b-col>
                <b-col lg="4">
                  <div>
                    <strong>COPD :</strong> {{ item.datas.pt_copd_name }}
                  </div>
                </b-col>
                <b-col lg="4">
                  <div>
                    <strong>Heart Failed ๖MW :</strong>
                    {{ item.datas.pt_hf_name }}
                  </div>
                </b-col>
              </div>
              <div>
                <b-col lg="4">
                  <div>
                    <strong>ไต ๖MW :</strong> {{ item.datas.pt_hd_name }}
                  </div>
                </b-col>
                <b-col lg="4">
                  <div>
                    <strong>Sit and reach :</strong>
                    {{ item.datas.pt_sit_name }}
                  </div>
                </b-col>
                <b-col lg="4">
                  <div>
                    <strong>เท้าเบาหวาน :</strong> {{ item.datas.pt_dm_name }}
                  </div>
                </b-col>
              </div>

              <hr class="hr-custom" />
              <div class="log-style">
                Log. {{ item.datas.pt_user }} |
                {{ thaiDatetimeFc.ThaiDateTime(item.datas.pt_datetime) }}
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-alert>

    <div>
      <b-row v-if="this.$store.get('systems@LoginData')">
        <div>
          <b-modal
            id="bv-modal-pt-note"
            hide-footer
            size="xl"
            v-if="this.PtIndicatorsDiag"
            :no-close-on-backdrop="true"
            :close-on-esc="true"
          >
            <template slot="modal-title">
              PT (กายภาพบำบัด)
            </template>

            <div class="d-block text-left margin-bottom" style="color:#000000;">
              <ckeditor
                :editor="editor"
                v-model="UserOPDNoteDatavalue"
                :config="editorConfig"
              ></ckeditor>
            </div>

            <b-row>
              <b-col lg="3" class="margin-bottom" v-if="EmrTemplateData">
                <b-form-select
                  v-model="EmrTemplateSelected"
                  :options="EmrTemplateData"
                  size="sm"
                ></b-form-select>
              </b-col>
              <b-col lg="3" class="margin-bottom" v-if="EmrTemplateData">
                <b-button
                  variant="success"
                  size="sm"
                  class="d-print-none"
                  @click="SubmitAddTemplate('AddTemplate')"
                  >Add Template</b-button
                >
              </b-col>

              <b-col lg="2" class="margin-bottom">
                <b-button
                  variant="info"
                  size="sm"
                  class="d-print-none"
                  @click="SubmitAddTemplate('AddTemplateLast')"
                  v-if="this.$store.get('systems@PTTemplateLast') != ''"
                  >ดึง PT ล่าสุด</b-button
                >
              </b-col>
            </b-row>

            <b-row class="margin-bottom">
              <b-col lg="12" v-if="this.PtIndicatorsDiag">
                <!-- Using components -->
                <b-input-group prepend="Dx กายภาพ" size="sm">
                  <b-form-select
                    v-model="PtDiagSelected"
                    :options="this.PtIndicatorsDiag"
                  ></b-form-select>
                  <b-input-group-append>
                    <b-button
                      variant="success"
                      class="d-print-none"
                      @click="
                        addDxDataList(
                          PtDiagSelected,
                          'PT' +
                            pjFunctionsFc.GenDateTimeID() +
                            pjFunctionsFc.RandomString(4),
                          ptVN,
                          ptHN
                        )
                      "
                      >เพิ่มรายการ</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>

            <b-row class="margin-bottom">
              <b-col lg="12">
                <b-list-group>
                  <b-list-group-item
                    button
                    v-for="(item, index) in this.PtDxList"
                    v-bind:key="item.id"
                    variant="info"
                    class="padding-bottom-top d-print-none"
                    >{{ index + 1 }}. {{ item.pt_indicators_name }}
                    <b-button
                      variant="danger"
                      size="sm"
                      style="float: right;"
                      @click="
                        deleteDxDataList(
                          item.id,
                          item.add_status,
                          item.vn,
                          item.hn
                        )
                      "
                      >ลบ</b-button
                    >
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>

            <b-row class="margin-bottom">
              <b-col lg="8">
                <b-form-select
                  size="sm"
                  v-model="PtDchSumSelected"
                  :options="PtIndicatorsDchSum"
                ></b-form-select>
              </b-col>
            </b-row>

            <b-row class="margin-bottom">
              <b-col lg="12">
                <b-form-input
                  placeholder="หมายเหตุ"
                  size="sm"
                  v-model="PtIndicatorsDchText"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="margin-bottom">
              <b-col lg="4">
                <!-- Using components -->
                <b-input-group prepend="PS" size="sm">
                  <b-form-select
                    v-model="PtPsSelected"
                    :options="PtIndicatorsPs"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <!-- Using components -->
                <b-input-group prepend="BI" size="sm">
                  <b-form-select
                    v-model="PtBiSelected"
                    :options="PtIndicatorsBi"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <!-- Using components -->
                <b-input-group prepend="MRM ROM ไหล่" size="sm">
                  <b-form-select
                    v-model="PtMrmRomSelected"
                    :options="PtIndicatorsMrmRom"
                  ></b-form-select>
                </b-input-group>
              </b-col>
            </b-row>

            <b-row class="margin-bottom">
              <b-col lg="4">
                <!-- Using components -->
                <b-input-group prepend="TKA ROM เข่า" size="sm">
                  <b-form-select
                    v-model="PtTkaRomSelected"
                    :options="PtIndicatorsTkaRom"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <!-- Using components -->
                <b-input-group prepend="COPD ๖MW" size="sm">
                  <b-form-select
                    v-model="PtCopdSelected"
                    :options="PtIndicatorsCopd"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <!-- Using components -->
                <b-input-group prepend="ไต ๖MW" size="sm">
                  <b-form-select
                    v-model="PtHdSelected"
                    :options="PtIndicatorsHd"
                  ></b-form-select>
                </b-input-group>
              </b-col>
            </b-row>

            <b-row class="margin-bottom">
              <b-col lg="4">
                <!-- Using components -->
                <b-input-group prepend="Heart Failed ๖MW" size="sm">
                  <b-form-select
                    v-model="PtHfSelected"
                    :options="PtIndicatorsHf"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <!-- Using components -->
                <b-input-group prepend="Sit and reach" size="sm">
                  <b-form-select
                    v-model="PtSitSelected"
                    :options="PtIndicatorsSit"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <!-- Using components -->
                <b-input-group prepend="เท้าเบาหวาน" size="sm">
                  <b-form-select
                    v-model="PtDmSelected"
                    :options="PtIndicatorsDm"
                  ></b-form-select>
                </b-input-group>
              </b-col>
            </b-row>

            <div class="d-block text-center">
              <b-button
                variant="success"
                size="sm"
                class="d-print-none"
                @click="SubmitOpdPtNote('add')"
                >บันทึก</b-button
              >
              &nbsp;
              <b-button
                size="sm"
                class="d-print-none"
                @click="$bvModal.hide('bv-modal-pt-note')"
                >ยกเลิก</b-button
              >
              &nbsp;
              <b-button
                variant="danger"
                size="sm"
                class="float-right d-print-none"
                @click="DeletePtNoteMsgBox('Delete')"
                v-if="this.OpdPtNoteDataInD"
                >ลบ</b-button
              >
            </div>
          </b-modal>
        </div>
      </b-row>
    </div>

    <div v-show="false">
      <b-button
        variant="primary"
        size="sm"
        class="pt-bt-style d-print-none"
        v-b-modal.bv-modal-pt-note
        >บันทึก PT (กายภาพบำบัด)</b-button
      >
    </div>

    <!-- CSS animation example -->
    <notifications
      group="ansn-foo-css"
      position="top right"
      animation-name="v-fade-left"
      :speed="500"
    >
    </notifications>

    <!-- Custom template example -->
    <notifications
      group="ansn-custom-save"
      :speed="500"
      animation-name="v-fade-left"
      position="bottom right"
    >
      <template slot="body" slot-scope="props">
        <div class="ansn-custom-save">
          <div
            class="notification-wrapper cursor-pointer"
            style="transition-timing-function: ease; transition-delay: 0s; transition-property: all;"
            @click="props.close"
          >
            <div class="vue-notification-template vue-notification">
              <div class="notification-title">{{ props.item.title }}</div>
              <div class="custom-template-text" v-html="props.item.text"></div>
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import PatientEmrPtData from "@/models/patientEMRs/PatientEmrPtData";
import PatientEmrPtIndicator from "@/models/patientEMRs/PatientEmrPtIndicator";
import PatientEmrPtDxData from "@/models/patientEMRs/PatientEmrPtDxData";
import PatientEmrPtDxDataList from "@/models/patientEMRs/PatientEmrPtDxDataList";
import PatientEmrPtTemplate from "@/models/patientEMRs/PatientEmrPtTemplate";

import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";

import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Font from "@ckeditor/ckeditor5-font/src/font";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      time1: "",
      value12: "",
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: [
          "next 7 days",
          "next 30 days",
          "previous 7 days",
          "previous 30 days"
        ],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        }
      },
      EmrTemplateSelected: null,
      EmrTemplateData: null,
      PtDiagSelected: null,
      status: false,
      vnStart: "",
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      OpdPtNoteDataInD: null,
      OpdPtNoteData: null,
      OpdPtNoteTextData: null,
      apiCk: 0,
      ptHN: "",
      ptVN: "",
      conF: "",
      UserDT: null,
      OpdPtNoteCh: "",
      UserOPDNoteData: "",
      UserOPDNoteFullData: null,
      UserOPDNoteDatavalue: "",
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          Font,
          Highlight,
          Alignment
        ],

        minHeight: "300px",

        fontSize: {
          options: ["default", 9, 11, 13, 15, 17, 19, 21, 23, 25, 27]
        },

        toolbar: {
          items: [
            // 'fontFamily',
            "bold",
            "italic",
            "|",
            "fontSize",
            "fontColor",
            "highlight",
            "alignment",
            "|",
            "undo",
            "redo"
          ]
        }
      },
      PtIndicatorsDchText: "",
      PtIndicatorsDiag: null,
      PtIndicatorsDchSum: null,
      PtDchSumSelected: "",
      PtIndicatorsPs: null,
      PtPsSelected: "",
      PtIndicatorsBi: null,
      PtBiSelected: "",
      PtIndicatorsMrmRom: null,
      PtMrmRomSelected: "",
      PtIndicatorsTkaRom: null,
      PtTkaRomSelected: "",
      PtIndicatorsCopd: null,
      PtCopdSelected: "",
      PtIndicatorsHd: null,
      PtHdSelected: "",
      PtIndicatorsHf: null,
      PtHfSelected: "",
      PtIndicatorsSit: null,
      PtSitSelected: "",
      PtIndicatorsDm: null,
      PtDmSelected: "",
      PtDxList: null,
      PtDxListConfirm: null
    };
  },
  props: ["MyVn", "MyHn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientEmrPtData,
    PatientEmrPtIndicator,
    PatientEmrPtDxData,
    PatientEmrPtDxDataList,
    PatientEmrPtTemplate
  },
  created() {
    (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods),
      this.vnChang;
    this.setPtIndicators();
    this.getEmrTemplate("pt");
  },
  watch: {
    ptHN: function() {
      // this.setOpdPtNote(this.ptVN,this.ptHN)
    },
    ptVN: function() {
      this.setOpdPtNote(this.ptVN, this.ptHN);
      // this.getUserOPDPtNote(this.ptVN,this.ptHN)
    },
    OpdPtNoteCh: function() {
      this.getOpdPtNote(this.ptVN, this.ptHN);
      // this.getUserOPDPtNote(this.ptVN,this.ptHN)
    },
    UserDT: function() {
      this.getOpdPtNote(this.ptVN, this.ptHN);
      // this.getUserOPDPtNote(this.ptVN,this.ptHN)
    }
  },
  computed: {
    vnChang() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
      this.UserDT = this.$store.get("systems@LoginData");
    }
  },
  methods: {
    SubmitAddTemplate(act) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("คุณแน่ใจที่จะ Add Template ใช่หรือไม่. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            if (act == "AddTemplate") {
              let ScrObj = PatientEmrPtTemplate.query()
                .where("id", this.EmrTemplateSelected)
                .get();

              if (ScrObj.length > 0) {
                this.UserOPDNoteDatavalue = ScrObj[0].datas.pt_template_text;
              }
            }

            if (act == "AddTemplateLast" && act != "undefined") {
              if (this.$store.get("systems@PTTemplateLast") != "") {
                // console.log('PPP', this.$store.get('systems@PTTemplateLast'))

                this.UserOPDNoteDatavalue = this.$store.get(
                  "systems@PTTemplateLast"
                );
              }
            }
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    DeletePtNoteMsgBox(std) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("คุณแน่ใจที่จะลบข้อมูลใช่หรือไม่. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            this.DeleteOpdPtNote(std);
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    show(group, type = "", title = "", text = "") {
      //const text = `
      //  This is notification text!
      //  <br>
      //  Date: ${new Date()}
      // `
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    DeleteOpdPtNote(std) {
      if (this.ptVN != "" && this.ptHN != "") {
        let datas = {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          vn: this.ptVN,
          hn: this.ptHN
        };

        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "OpdPtDataDelete", datas)
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              // ScrObj.setOpdPtNote(ScrObj.ptVN,ScrObj.ptHN)

              PatientEmrPtData.delete({
                where(record) {
                  return record.vn == ScrObj.ptVN;
                }
              });

              PatientEmrPtDxData.delete({
                where(record) {
                  return record.vn == ScrObj.ptVN;
                }
              });

              ScrObj.UserOPDNoteDatavalue = " ";

              ScrObj.show(
                "ansn-foo-css",
                "success",
                "Delete Data Success",
                "การลบข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              ScrObj.$bvModal.hide("bv-modal-pt-note");
            } else {
              ScrObj.show(
                "ansn-foo-css",
                "warn",
                "Save Data Error",
                "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output.ErrorMessage +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
            }
          })
          .catch(function(error) {
            ScrObj.output = error;

            ScrObj.show(
              "ansn-foo-css",
              "error",
              "Save Data Error",
              "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                "<br>ErrorMessage : " +
                ScrObj.output +
                "<br>Date : " +
                ScrObj.thaiDatetimeFc.ThaiDateTime(
                  ScrObj.thaiDatetimeFc.DateTimeNow()
                )
            );

            console.log("OpdPtNoteAdd : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.setOpdPtNote(ScrObj.ptVN, ScrObj.ptHN);
          });
      }
    },
    SubmitOpdPtNote(std) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("ยืนยันการบันทึกข้อมูล. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            if (
              this.ptVN != "" &&
              this.ptHN != "" &&
              this.UserOPDNoteDatavalue != ""
            ) {
              let NoteText = "";

              if (std == "Delete") {
                NoteText = "-";
              } else {
                NoteText = this.UserOPDNoteDatavalue;
              }

              let PtDxListObj = PatientEmrPtDxDataList.query()
                .where(record => record.hn == this.ptHN)
                .where(record => record.vn == this.ptVN)
                .get();

              let datas = {
                CompanyId: this.$store.get("systems@CompanyId"),
                ApiKey: this.$store.get("systems@ApiKey"),
                vn: this.ptVN,
                hn: this.ptHN,
                pt_text: NoteText,
                pt_ps: this.PtPsSelected,
                pt_bi: this.PtBiSelected,
                pt_mrm_rom: this.PtMrmRomSelected,
                pt_tka_rom: this.PtTkaRomSelected,
                pt_copd: this.PtCopdSelected,
                pt_hf: this.PtHfSelected,
                pt_hd: this.PtHdSelected,
                pt_sit: this.PtSitSelected,
                pt_dm: this.PtDmSelected,
                pt_dch: this.PtDchSumSelected,
                pt_dch_text: this.PtIndicatorsDchText,
                pt_dx: PtDxListObj
              };

              let ScrObj = this;
              this.axios
                .post(this.$store.get("systems@UrlApi") + "OpdPtDataAdd", datas)
                .then(function(response) {
                  ScrObj.output = response.data;
                  if (ScrObj.output.status === true) {
                    // ScrObj.setOpdPtNote(ScrObj.ptVN,ScrObj.ptHN)

                    ScrObj.show(
                      "ansn-foo-css",
                      "success",
                      "Save Data Success",
                      "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                        ScrObj.thaiDatetimeFc.ThaiDateTime(
                          ScrObj.thaiDatetimeFc.DateTimeNow()
                        )
                    );

                    ScrObj.$bvModal.hide("bv-modal-pt-note");
                  } else {
                    ScrObj.show(
                      "ansn-foo-css",
                      "warn",
                      "Save Data Error",
                      "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                        "<br>ErrorMessage : " +
                        ScrObj.output.ErrorMessage +
                        "<br>Date : " +
                        ScrObj.thaiDatetimeFc.ThaiDateTime(
                          ScrObj.thaiDatetimeFc.DateTimeNow()
                        )
                    );

                    // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
                  }
                })
                .catch(function(error) {
                  ScrObj.output = error;

                  ScrObj.show(
                    "ansn-foo-css",
                    "error",
                    "Save Data Error",
                    "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                      "<br>ErrorMessage : " +
                      ScrObj.output +
                      "<br>Date : " +
                      ScrObj.thaiDatetimeFc.ThaiDateTime(
                        ScrObj.thaiDatetimeFc.DateTimeNow()
                      )
                  );

                  console.log("OpdPtNoteAdd : " + ScrObj.output);
                })
                .finally(function() {
                  ScrObj.setOpdPtNote(ScrObj.ptVN, ScrObj.ptHN);
                });
            }
          }
        });
    },
    OpdPtNoteReplace(txt) {
      String.prototype.replaceAll = function(search, replacement) {
        var target = this;
        return target.split(search).join(replacement);
      };
      let PgNote = txt;
      PgNote = PgNote.replaceAll("<br />", "\n");
      PgNote = PgNote.replaceAll("<br>", "\n");
      PgNote = PgNote.replaceAll("<br >", "\n");
      return PgNote;
    },
    setOpdPtNote(vn, hn) {
      this.OpdPtNoteCh = "OpdPtNote" + vn;

      let CkScrObj = PatientEmrPtData.query()
        .where("hn", hn)
        .where("vn", vn)
        .get();

      if (vn != "" && vn != null && CkScrObj.length >= 0) {
        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "OpdPtData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              PatientEmrPtData.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              let data = [];
              for (var val of ScrObj.output.result) {
                data.push({
                  id: val.vn + val.loginname,
                  loginname: val.loginname,
                  vn: val.vn,
                  hn: val.hn,
                  datas: val
                });
              }

              PatientEmrPtData.insertOrUpdate({
                data
              });
            } else {
              if (ScrObj.output.ErrorMessage === "Data Not Found") {
                PatientEmrPtData.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            ScrObj.output = error;
            console.log("OpdPtNote : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.OpdPtNoteCh = "OpdPtNote" + vn;
            ScrObj.getOpdPtNote(vn, hn);
            // ScrObj.getUserOPDPtNote(vn,hn)
          });

        let DxObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "OpdPtDiagData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            DxObj.output = response.data;
            if (DxObj.output.status === true) {
              PatientEmrPtDxData.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              let data = [];
              for (var val of DxObj.output.result) {
                data.push({
                  id: val.pt_dx_id,
                  loginname: val.loginname,
                  vn: val.vn,
                  hn: val.hn,
                  datas: val
                });
              }

              PatientEmrPtDxData.insertOrUpdate({
                data
              });
            } else {
              if (DxObj.output.ErrorMessage === "Data Not Found") {
                PatientEmrPtDxData.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            DxObj.output = error;
            console.log("OpdPtDxData : " + DxObj.output);
          })
          .finally(function() {
            DxObj.OpdPtNoteCh = "OpdPtDxData" + vn;
            DxObj.getOpdPtNote(vn, hn);
            // DxObj.getUserOPDPtNote(vn,hn)
          });
      }
    },
    getOpdPtNote(vn, hn) {
      let ScrObj = PatientEmrPtData.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .where(record => record.datas.pt_status == "Y")
        .get();

      if (ScrObj.length > 0) {
        this.OpdPtNoteDataInD = ScrObj;

        this.PtIndicatorsDchText = ScrObj[0].datas.pt_dch_text;

        this.PtDchSumSelected = ScrObj[0].datas.pt_dch;
        this.PtPsSelected = ScrObj[0].datas.pt_ps;
        this.PtBiSelected = ScrObj[0].datas.pt_bi;
        this.PtCopdSelected = ScrObj[0].datas.pt_copd;
        this.PtMrmRomSelected = ScrObj[0].datas.pt_mrm_rom;
        this.PtTkaRomSelected = ScrObj[0].datas.pt_tka_rom;
        this.PtHdSelected = ScrObj[0].datas.pt_hd;
        this.PtHfSelected = ScrObj[0].datas.pt_hf;
        this.PtSitSelected = ScrObj[0].datas.pt_sit;
        this.PtDmSelected = ScrObj[0].datas.pt_dm;

        this.UserOPDNoteDatavalue = ScrObj[0].datas.pt_text;

        this.apiCk = this.apiCk + 1;
      } else {
        this.OpdPtNoteDataInD = null;
        this.PtIndicatorsDchText = "";
        this.apiCk = this.apiCk + 1;

        this.PtDchSumSelected = "";
        this.PtPsSelected = "";
        this.PtBiSelected = "";
        this.PtMrmRomSelected = "";
        this.PtTkaRomSelected = "";
        this.PtCopdSelected = "";
        this.PtHdSelected = "";
        this.PtHfSelected = "";
        this.PtSitSelected = "";
        this.PtDmSelected = "";

        this.UserOPDNoteDatavalue = " ";
      }

      let ScrObj2 = PatientEmrPtDxData.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .where(record => record.datas.delete_status != "Y")
        .get();

      if (ScrObj2.length > 0) {
        PatientEmrPtDxDataList.delete({
          where(record) {
            return record.vn == vn;
          }
        });

        let data = [];
        for (var val of ScrObj2) {
          data.push({
            id: val.datas.pt_dx_id + val.datas.vn + val.datas.hn,
            pt_dx_id: val.datas.pt_dx_id,
            hn: val.datas.hn,
            vn: val.datas.vn,
            pt_indicators_id: val.datas.pt_indicators_id,
            pt_indicators_name: val.datas.pt_indicators_name,
            add_status: "",
            delete_status: val.datas.delete_status
          });
        }

        PatientEmrPtDxDataList.insertOrUpdate({
          data
        });

        let ScrObj3 = PatientEmrPtDxDataList.query()
          .where(record => record.hn == hn)
          .where(record => record.vn == vn)
          .where(record => record.delete_status != "Y")
          .get();

        this.PtDxList = ScrObj3;

        let ScrObj4 = PatientEmrPtDxDataList.query()
          .where(record => record.hn == hn)
          .where(record => record.vn == vn)
          .where(record => record.delete_status != "Y")
          .where(record => record.add_status != "add")
          .get();

        this.PtDxListConfirm = ScrObj4;
      } else {
        this.PtDxList = null;
      }

      /* 
        // #### PT Data Last #### 
        let PtObjMx = PatientEmrPtData.query()
        .where('hn', hn)
        .orderBy('vn', 'desc')
        .limit(1)
        .get() 

        if(PtObjMx.length > 0) {

          // console.log(PtObjMx[0].datas.pt_text)

          this.EmrTemplateLast = PtObjMx[0].datas.pt_text
        } else {
          this.EmrTemplateLast = ''
        }
        */
    },
    /*
      getUserOPDPtNote(vn,hn){
        
        if(this.$store.get('systems@LoginData')){

          let ScrObj = PatientEmrPtData.query()
          .where(record => record.datas.hn == hn)
          .where(record => record.datas.vn == vn)
          .where(record => record.datas.delete_status != 'Y')
          .where(record => record.datas.pt_status == 'Y')
          .get()

          if(ScrObj.length > 0){ 

            this.UserOPDNoteFullData = ScrObj[0] 
            this.UserOPDNoteData = ScrObj[0].datas.pt_text

            this.UserOPDNoteDatavalue = this.UserOPDNoteData

            this.apiCk = (this.apiCk+1)
          } else {

            this.UserOPDNoteFullData = null
            this.UserOPDNoteData = ''

            this.UserOPDNoteDatavalue = this.UserOPDNoteData

          }

        } else {

          this.UserOPDNoteFullData = null
          this.UserOPDNoteData = ''

          this.UserOPDNoteDatavalue = ''

        }
        
      }, */
    getEmrTemplate(TemplateType) {
      this.EmrTemplateSelected = null;

      let ScrObj = PatientEmrPtTemplate.query()
        .where(record => record.pt_template_status == "Y")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: null,
          text: "Please select Template"
        });
        for (var val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_template_name
          });
        }

        this.EmrTemplateData = data;
      } else {
        this.EmrTemplateData = null;
      }
    },
    setPtIndicators() {
      this.PtDiagSelected = "";
      this.PtDchSumSelected = "";
      this.PtPsSelected = "";
      this.PtBiSelected = "";
      this.PtMrmRomSelected = "";
      this.PtTkaRomSelected = "";
      this.PtHdSelected = "";
      this.PtHfSelected = "";
      this.PtSitSelected = "";
      this.PtDmSelected = "";

      let ScrObj = null;
      let val = null;

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "dx")
        .orderBy("pt_indicators_orderby")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: Dx กายภาพ ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsDiag = data;
      } else {
        this.PtIndicatorsDiag = null;
      }

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "dch")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: สรุปผลการรักษา ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsDchSum = data;
      } else {
        this.PtIndicatorsDchSum = null;
      }

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "ps")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: PS ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsPs = data;
      } else {
        this.PtIndicatorsPs = null;
      }

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "bi")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: BI ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsBi = data;
      } else {
        this.PtIndicatorsBi = null;
      }

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "mrm_rom")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: MRM ROM ไหล่ ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsMrmRom = data;
      } else {
        this.PtIndicatorsMrmRom = null;
      }

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "tka_rom")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: TKA ROM เข่า ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsTkaRom = data;
      } else {
        this.PtIndicatorsTkaRom = null;
      }

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "copd")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: COPD ๖MW ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsCopd = data;
      } else {
        this.PtIndicatorsCopd = null;
      }

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "hd")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: ไต ๖MW ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsHd = data;
      } else {
        this.PtIndicatorsHd = null;
      }

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "hf")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: Heart Failed ๖MW ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsHf = data;
      } else {
        this.PtIndicatorsHf = null;
      }

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "sit")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: Sit and reach ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsSit = data;
      } else {
        this.PtIndicatorsSit = null;
      }

      ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "dm")
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: เท้าเบาหวาน ::."
        });
        for (val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.pt_indicators_name
          });
        }
        this.PtIndicatorsDm = data;
      } else {
        this.PtIndicatorsDm = null;
      }
    },
    deleteDxDataList(dx_id, add_status, vn, hn) {
      // Update via function.

      if (add_status == "add") {
        PatientEmrPtDxDataList.delete(record => {
          return record.id == dx_id;
        });
      } else {
        PatientEmrPtDxDataList.update({
          where: record => {
            return record.id == dx_id;
          },
          data: { delete_status: "Y" }
        });
      }

      let ScrObj3 = PatientEmrPtDxDataList.query()
        .where(record => record.hn == hn)
        .where(record => record.vn == vn)
        .where(record => record.delete_status != "Y")
        .get();

      this.PtDxList = ScrObj3;
    },
    addDxDataList(pt_indicators_id, randomID, vn, hn) {
      // Update via function.
      let ScrObj = PatientEmrPtIndicator.query()
        .where(record => record.datas.pt_indicators_type == "dx")
        .where(record => record.datas.pt_indicators_id == pt_indicators_id)
        .get()[0];

      let ScrObj2 = PatientEmrPtDxDataList.query()
        .where(record => record.hn == hn)
        .where(record => record.vn == vn)
        .where(record => record.pt_indicators_id == pt_indicators_id)
        .get();

      if (ScrObj2.length <= 0) {
        let data = [];
        data.push({
          id: randomID,
          pt_dx_id: randomID,
          hn: hn,
          vn: vn,
          pt_indicators_id: pt_indicators_id,
          pt_indicators_name: ScrObj.datas.pt_indicators_name,
          add_status: "add",
          delete_status: ""
        });

        PatientEmrPtDxDataList.insertOrUpdate({
          data
        });

        let ScrObj3 = PatientEmrPtDxDataList.query()
          .where(record => record.hn == hn)
          .where(record => record.vn == vn)
          .where(record => record.delete_status != "Y")
          .get();

        this.PtDxList = ScrObj3;
      } else {
        PatientEmrPtDxDataList.update({
          where: record => {
            return record.pt_indicators_id == pt_indicators_id;
          },
          data: { delete_status: "" }
        });

        let ScrObj3 = PatientEmrPtDxDataList.query()
          .where(record => record.hn == hn)
          .where(record => record.vn == vn)
          .where(record => record.delete_status != "Y")
          .get();

        this.PtDxList = ScrObj3;
      }
    }
  }
})
export default class EmrOpdPtNote extends Vue {}
</script>

<style lang="scss">
.pt-bt-style {
  color: #ad008b !important;
  background-color: pink !important;
  border-color: deeppink !important;
}

.padding-bottom-top {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.pt-bt-style:hover {
  color: #ad008b !important;
  background-color: rgb(255, 144, 162) !important;
  border-color: deeppink !important;
}

.pt-bt-style:hover:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 144, 163, 0.452) !important;
}

.ck {
  p {
    margin: 0;
  }
}

.opd-pt-note-text {
  p {
    margin: 0;
  }
}

.ck-editor__editable {
  min-height: 200px;
}
</style>

